// extracted by mini-css-extract-plugin
export default {"buttons":"FormButtons_buttons__9qKGC","spinner":"FormButtons_spinner__neVCL","spin":"FormButtons_spin__soxNm"};